import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: '!p-4 !text-lg',
          error: '!text-destructive !border-destructive',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
